export default () => {
  if (process.client) {
    const injectScripts = () => {
      if (process.env.SALESMARTLY_KEY) {
        const sm = document.createElement('script');
        sm.src = `https://assets.salesmartly.com/js/${process.env.SALESMARTLY_KEY}.js`;
        sm.async = true;
        document.body.appendChild(sm);
      }
    };

    let injected = false;
    const trigger = () => {
      if (injected) return;
      injected = true;
      injectScripts();
      ['scroll', 'mousemove', 'touchstart'].forEach(e => window.removeEventListener(e, trigger));
    };

    // Delay for 3 seconds or trigger immediately on user interaction
    setTimeout(trigger, 3000);
    ['scroll', 'mousemove', 'touchstart'].forEach(e => window.addEventListener(e, trigger, { once: true, passive: true }));
  }
};
